export interface CreateVoiceMeetingParams extends CreateVoiceMeetingFromSessionParams {
  callId: number;
  deafPhoneNumber: string;
  hearingPhoneNumber: string;
}

export interface CreateVoiceMeetingFromSessionParams {
  agentUserName: string;
}

export interface TeamingSpeakerContext {
  isActive: boolean;
  otherInterpreterAgentId: string;
}

export const initialTeamingSpeakerContext: TeamingSpeakerContext = {
  isActive: false,
  otherInterpreterAgentId: '',
};
